import { useState } from "react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Stack,
} from "@altimateai/lego";
import { IconInfoCircle, IconChevronDown, IconChevronUp } from "@tabler/icons-react";

export const AzureSetupGuide = () => {
  const [open, setOpen] = useState(false);
  return (
    <Alert variant="info">
      <IconInfoCircle className="al-h-4 al-w-4" />
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger asChild>
          <Stack direction="row" className="al-items-center al-gap-1 al-cursor-pointer al-w-full">
            <AlertTitle className="al-m-0">Azure AD Setup Guide</AlertTitle>
            {open ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
          </Stack>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <AlertDescription className="al-mt-2">
            <ol className="al-list-decimal al-pl-4 al-space-y-1 al-text-sm">
              <li>
                In Azure Portal, go to{" "}
                <strong>App Registrations &gt; Your App &gt; Token Configuration</strong>.
              </li>
              <li>
                Click <strong>Add groups claim</strong> and select the group types to include
                (Security groups, Directory roles, etc.).
              </li>
              <li>
                Azure AD limits groups in tokens to approximately 200 (JWT/OIDC) or 150 (SAML). If
                your users belong to more groups, Azure omits them from the token entirely.
              </li>
              <li>
                For organizations exceeding this limit, enable{" "}
                <strong>Fetch groups via Microsoft Graph API</strong> below and provide your Tenant
                ID.
              </li>
            </ol>
          </AlertDescription>
        </CollapsibleContent>
      </Collapsible>
    </Alert>
  );
};
